import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { cn } from '../../lib/cn.js';
const PALETTE = [
    { bg: 'bg-primary', text: 'text-text-inverse' },
    { bg: 'bg-accent', text: 'text-avatar-on-accent' },
    { bg: 'bg-primary-border', text: 'text-avatar-on-primary-border' },
];
const SIZE_CLASSES = {
    sm: 'size-8 text-body-sm',
    md: 'size-10 text-body',
    lg: 'size-14 text-h4',
};
function paletteFor(seed) {
    let hash = 0;
    for (const char of seed)
        hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
    // Non-null: hash % PALETTE.length is always a valid index into a fixed,
    // non-empty array literal.
    return PALETTE[hash % PALETTE.length];
}
function initialsFor(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    return parts
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase())
        .join('');
}
/** Avatar (README.md > Atoms). Colour is assigned deterministically from
 * a fixed 3-colour set, keyed off `name`, so the same person always gets
 * the same colour without a lookup table. */
export function Avatar({ name, size = 'md', src, className }) {
    const palette = paletteFor(name);
    const [failedSrc, setFailedSrc] = useState(null);
    const photo = src && src !== failedSrc ? src : null;
    return (_jsx("span", { role: "img", "aria-label": name, className: cn('inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold', SIZE_CLASSES[size], palette.bg, palette.text, className), children: photo ? (_jsx("img", { src: photo, 
            // The span carries the name; the picture adds nothing to read aloud.
            alt: "", 
            // Provider CDNs such as Google's refuse some referrers, and none is
            // needed to load a picture.
            referrerPolicy: "no-referrer", className: "size-full rounded-full object-cover", onError: () => setFailedSrc(photo) })) : (initialsFor(name)) }));
}
//# sourceMappingURL=Avatar.js.map